import styled from "@emotion/styled";

const colors = {
  pending: { bg: "#fff7e6", fg: "#a35d00" },
  approved: { bg: "#e6f5ec", fg: "#1f7a3f" },
  rejected: { bg: "#ffeaea", fg: "#a02323" },
  canceled: { bg: "#eef0f3", fg: "#555555" },
};

const StatusTag = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 999px;
  background: ${({ status }) => (colors[status] || colors.pending).bg};
  color: ${({ status }) => (colors[status] || colors.pending).fg};
`;

export default StatusTag;
